import React, { Component } from "react";

import { Link } from "react-router-dom";
// import {Link} from 'react-router-dom'
import { Menu } from "semantic-ui-react";

import Footer from "../../FooterMain";
import menus from "../Helpers/menus";
import { withRouter } from 'react-router'
import HeaderCommon from "../../HeaderCommon";
import decode from "jwt-decode";
import colors from "../../colors";

import {
  Navbar,
  NavbarNav,
  NavbarToggler,
  Collapse,
  NavItem,
  NavLink,
  Button,
} from "mdbreact";
import { AuthConsumer } from "../../AuthContext";
class Layout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapse: false,
      isWideEnough: false,
      dropdownOpenAbout: false,
      dropdownOpenTeams: false,
      dropdownOpenProjects: false,
      active: props.match.url === '/trainingnew' ? 'Training Home' : props.match.url === '/trainingnew/courses' ? 'Courses' : props.match.url === '/trainingnew/proj-obj' ? 'Objective' : null,
      isOpen: false,
      trmodal:true,
    };
  }
toggle=()=>{
  this.setState({
    trmodal:!this.state.trmodal
  })
}
  onClick = () => {
    this.setState({
      collapse: !this.state.collapse,
    });
  };
  _handleClick(menuItem) {
    this.setState({ active: menuItem });
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.props.match.url !== prevProps.match.url) {
      this.setState({
        active: this.props.match.url === '/trainingnew' ? 'Training Home' : this.props.match.url === '/trainingnew/courses' ? 'Courses' : this.props.match.url === '/trainingnew/proj-obj' ? 'Objective' : null,
      })
    }
  }
  render() {
    const activeStyle = { color: "#ff3333" };
    let menuList = menus.head.map((menu, key) => {
      return (
        <NavItem key={key}>
          <NavLink to={menu.path} key={key}>
            <Menu.Item
              name={menu.name}
              style={this.state.active === menu.name ? activeStyle : {}}
              onClick={this._handleClick.bind(this, menu.name)}
            />
          </NavLink>
        </NavItem>
      );
    });
    const childrenWithExtraProp = React.Children.map(
      this.props.children,
      (child, i) => {
        return React.cloneElement(child, {
        //this properties are available as a props in child components
         trmodal:this.state.trmodal,
          toggle: this.toggle,
          index: i
        });
      }
    );
    return (
      <div className="wrapper">
        <HeaderCommon title=" Capacity Building " screentitle="Capacity Building " bhuvanlink={true} />
        <Navbar   dark expand="md" scrolling 
                  style={{ background: colors["final_header"], fontSize: "14px",fontWeight: "bold" }}
>
          {!this.state.isWideEnough && <NavbarToggler onClick={this.onClick} />}
          <Collapse isOpen={this.state.collapse} navbar>
            <NavbarNav left>{menuList}</NavbarNav>
            <NavbarNav right>
              {/* <NavItem>
      <NavLink to='/trainingnew/feedback' ><Menu.Item name="Training Feedback" style={this.state.active === 'Training Feedback' ? activeStyle : {}} 
                onClick={this._handleClick.bind(this, 'Training Feedback')}/></NavLink>  
      </NavItem> */}

              {/* <NavItem>
      <NavLink to='/trainingnew/photo-gallery' ><Menu.Item name="Photo Gallery" /></NavLink>  
      </NavItem> */}
            </NavbarNav>
            {/* <NavbarNav right>
              <NavItem>
                <NavLink to='/trainingnew/training-admin'  ><Menu.Item name="Training Admin" style={this.state.active === 'Training Admin' ? activeStyle : {}}
                  onClick={this._handleClick.bind(this, 'Training Admin')} /></NavLink>
              </NavItem>
            </NavbarNav> */}
            {/* <AuthConsumer>
              {({ isAuth, logout }) => (
                <NavbarNav right>

                  {(isAuth) || (localStorage.getItem("token") !== null) ? (
                    <NavbarNav right>

                      {(decode(localStorage.getItem('token')).id) === 'NR00000' ?
                        <NavbarNav right>
                          {/* <NavItem>
                                                        <NavLink to="/trainingNew/fin-prop"><Menu.Item name="Financial Proposal" style={this.state.active === 'Financial Proposal' ? activeStyle : {}}
                                                            onClick={this._handleClick.bind(this, 'Financial Proposal')} /></NavLink>
                                                    </NavItem> */}
                          {/* <NavItem>
                            <NavLink to='/trainingnew/training-admin'  ><Menu.Item name="Training Admin" style={this.state.active === 'Training Admin' ? activeStyle : {}}
                              onClick={this._handleClick.bind(this, 'Training Admin')} /></NavLink>
                          </NavItem>
                        </NavbarNav> : null}
                      <NavItem>
                        {decode(localStorage.getItem('token')).trainee === 'trainee' ? <Button className="btn-sm" outline color="yellow" >Welcome {decode(localStorage.getItem('token')).name}</Button> :
                          <Link to={`/profile/${decode(localStorage.getItem('token')).id}`}><Button className="btn-sm" outline color="yellow" >Welcome {decode(localStorage.getItem('token')).name}</Button></Link>
                        }          </NavItem>
                      <NavItem><Button className="btn-sm" onClick={logout}>logout</Button></NavItem>
                    </NavbarNav>
                  ) : (
                      <NavbarNav right>

                        <NavItem>
                          <NavLink to="/login">Login</NavLink>

                        </NavItem>

                      </NavbarNav>



                    )}

                </NavbarNav>
              )}
            </AuthConsumer> */} 
          </Collapse>
        </Navbar>

        <div className="main">{childrenWithExtraProp}</div>

        <Footer />
      </div>
    );
  }
}

export default withRouter(Layout);
